export enum ScifinderStatus {
  COMPLETE = 'Complete',
  GENERATING_PLAN = 'Generating Plan',
  SAVED = 'Saved Plan',
  UNAVAILABLE = 'Status Unavailable',
  NOT_FOUND = 'Not Found',
  EXPIRED = 'Expired',
  FAILED = 'Failed',
}
